import { Link } from 'react-router-dom';
import type { VarietyShow } from '@/mocks/shows';

interface ShowCardProps {
  show: VarietyShow;
  size?: 'normal' | 'large';
}

export default function ShowCard({ show, size = 'normal' }: ShowCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/article/${show.id}`}
      className="group block cursor-pointer"
    >
      <article className="relative overflow-hidden rounded-lg bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-200">
        <div className={`relative overflow-hidden ${isLarge ? 'aspect-[16/9]' : 'aspect-[3/4]'}`}>
          <img
            src={show.coverImage}
            alt={show.title}
            title={`${show.title} - 6789影院热门综艺节目在线观看`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div className="absolute top-2 left-2 flex items-center gap-1.5">
            <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
              {show.rating}
            </span>
          </div>
          {show.isHot && (
            <div className="absolute top-2 right-2">
              <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                热门
              </span>
            </div>
          )}
          <div className="absolute bottom-0 left-0 right-0 p-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            <span className="inline-block px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap cursor-pointer">
              立即观看
            </span>
          </div>
        </div>
        <div className="p-3 md:p-4">
          <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors duration-200">
            {show.title}
          </h3>
          <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
            {show.description}
          </p>
          <div className="mt-3 flex items-center justify-between">
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              {show.views} 播放
            </span>
            <span className="text-xs text-foreground-400 whitespace-nowrap">
              {show.episodeCount}期
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
}